
function isMobile() {
        return (window.innerWidth < 768) ? true : false;
}


export default {isMobile};
